import React from 'react';
import { Modal, Divider } from 'antd';
import { ModalContainer, ModalHeaderContainer } from './styles';

export default function BaseModal({ visible, title, onCancel, footerButtons, children }) {
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      width="70%"
      style={{ maxWidth: 1200 }}
      footer={footerButtons}
      destroyOnClose={true}
    >
      <ModalContainer>
        <ModalHeaderContainer>{title}</ModalHeaderContainer>

        <Divider />
        <div
          style={{
            width: '100%',
            maxWidth: 900,
            margin: 'auto',
            overflow: 'hidden'
          }}
        >
          {children}
        </div>
      </ModalContainer>
    </Modal>
  );
}
